module.exports = __webpack_public_path__ + "img/6.7853c2c4.jpg";